import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import Panel from '../../components/design/Panel';

export default function DashboardServers({ servers, serverCount, exporterCounts, activeAgentTypeCount, totalAgentTypes }) {
  const online = servers.filter(s => s.status === 'online').length;
  const offline = servers.filter(s => s.status === 'offline').length;
  const pending = servers.filter(s => s.status === 'pending').length;
  const donut = [
    { name: 'Online', value: online, fill: '#10b981' },
    { name: 'Offline', value: offline, fill: '#ef4444' },
    { name: 'Pending', value: pending, fill: '#f59e0b' },
  ].filter(d => d.value > 0);
  const legend = [
    { label: 'Online', count: online, color: '#10b981' },
    { label: 'Offline', count: offline, color: '#ef4444' },
    { label: 'Pending', count: pending, color: '#f59e0b' },
  ];

  return (
    <div className="grid grid-2 section-gap">
      <Panel title="Servers">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ position: 'relative' }}>
            <ResponsiveContainer width={140} height={140}>
              <PieChart>
                <Pie data={donut} cx="50%" cy="50%" innerRadius={34} outerRadius={58} dataKey="value" stroke="none">
                  <Cell fill="#10b981" /><Cell fill="#ef4444" /><Cell fill="#f59e0b" />
                </Pie>
                <text x="50%" y="46%" textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 20, fontWeight: 800, fill: 'var(--text-1)' }}>
                  {serverCount}
                </text>
                <text x="50%" y="62%" textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 9, fill: 'var(--text-3)' }}>
                  total
                </text>
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex gap-3 mt-1.5">
            {legend.map(st => (
              <div key={st.label} className="flex items-center gap-1">
                <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: st.color }} />
                <span className="muted">{st.label}</span>
                <span className="mono" style={{ fontWeight: 700, color: 'var(--text-1)' }}>{st.count}</span>
              </div>
            ))}
          </div>
        </div>
      </Panel>
      <Panel title="Agent Health by Group" sub={`${activeAgentTypeCount}/${totalAgentTypes} active`}>
        {exporterCounts.length === 0 ? (
          <div className="empty">No active exporters</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {exporterCounts.map(a => (
              <div key={a.label} className="list-row" style={{ padding: '6px 0' }}>
                <span className="lbl" style={{ flex: '0 0 130px', color: 'var(--text-2)', fontSize: 12.5 }}>{a.label}</span>
                <div className="progress" style={{ flex: 1 }}>
                  <span style={{ width: `${a.total > 0 ? Math.round((a.active / a.total) * 100) : 0}%`, background: 'var(--grad-main)' }} />
                </div>
                <b className="mono" style={{ fontSize: 12 }}>{a.active}/{a.total}</b>
              </div>
            ))}
          </div>
        )}
      </Panel>
    </div>
  );
}
